'use client'
import React, { useState } from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
} from '@chakra-ui/react'
import { useReportChannel } from '@/src/mutations/my-channel/report-channel'
import { toast } from 'sonner'

const ReportModal = ({
  isOpen,
  onClose,
  channelId,
}: {
  isOpen: boolean
  onClose: () => void
  channelId: string
}) => {
  const [selectedOption, setSelectedOption] = useState('')
  const [otherReason, setOtherReason] = useState('')

  const reportChannel = useReportChannel()

  const handleReport = () => {
    const reportData = {
      channel_id: channelId,
      comment: selectedOption === 'other' ? otherReason : selectedOption,
    }

    reportChannel.mutate(reportData, {
      onSuccess: () => {
        setSelectedOption('')
        setOtherReason('')
        onClose()
        toast.success(
          'User reported and hidden successfully. Our team will be in touch for any clarifications.'
        )
      },
      onError: (error) => {
        console.error('Failed to report channel:', error)
      },
    })
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent mx={4} borderRadius={'2xl!important'}>
          <ModalHeader color={'#3E3E3E99'}>Report user</ModalHeader>
          <ModalCloseButton color={'#3E3E3E99'} fontWeight={600} />
          <ModalBody>
            <RadioGroup onChange={setSelectedOption} value={selectedOption}>
              <Stack
                direction="column"
                spacing={3}
                color={'#3E3E3E99'}
                fontSize={18}
                fontWeight={500}
              >
                <Radio value="sexual-content">Sexual content</Radio>
                <Radio value="bullying-harassment">
                  Bullying or Harassment
                </Radio>
                <Radio value="hate-abuse">Hate/Abuse-filled content</Radio>
                <Radio value="harmful-content">Harmful content</Radio>
                <Radio value="violent-content">
                  Violent or repulsive content
                </Radio>
                <Radio value="misinformation">Misinformation</Radio>
                <Radio value="spam-misleading">Spam or Misleading</Radio>
                <Radio value="promotes-terrorism">Promotes Terrorism</Radio>
                <Radio value="other">Other</Radio>
              </Stack>
            </RadioGroup>

            {selectedOption === 'other' && (
              <Textarea
                mt={4}
                color={'#3E3E3E99'}
                placeholder="Please specify your reason"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                _focus={{
                  borderColor: 'transparent!important',
                  outlineColor: 'transparent!important',
                }}
                _active={{
                  borderColor: 'transparent!important',
                  outlineColor: 'transparent!important',
                }}
              />
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              mr={3}
              onClick={onClose}
              color={'#3E3E3E99'}
              bg={'transparent'}
              _hover={{ bg: '#24BFA3', color: 'white' }}
              _active={{ bg: '#24BFA3', color: 'white' }}
            >
              Cancel
            </Button>
            <Button
              color={'white'}
              bg={'#24BFA3'}
              _hover={{ bg: '#24BFA3', color: 'white' }}
              _active={{ bg: '#24BFA3', color: 'white' }}
              onClick={handleReport}
              isDisabled={
                !selectedOption || (selectedOption === 'other' && !otherReason)
              }
            >
              Report and hide user
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ReportModal
